var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from "styled-components";
import Icon from './IconBase';
function EyeInvisibleIcon(props) {
    if (!(props.width || props.height)) {
        props = Object.assign(__assign({}, props), { width: 20 });
    }
    return (React.createElement(Icon, __assign({ "data-icon": 'eyeInvisible', viewBox: "0 0 20 16" }, props),
        React.createElement("path", { d: "M19.827 5.53c.237.267.23.704-.017.96-3.362 3.506-6.623 5.352-9.785 5.501-.93.044-1.866-.082-2.81-.376l1.75-1.75c.33.088.677.135 1.035.135 2.21 0 4-1.79 4-4 0-.358-.047-.705-.135-1.036l2.604-2.605c1.11.836 2.229 1.894 3.358 3.17zM12.786.385l-1.75 1.75C10.707 2.048 10.36 2 10 2 7.79 2 6 3.79 6 6c0 .358.047.705.135 1.036L3.531 9.642C2.42 8.805 1.302 7.748.173 6.472c-.237-.268-.23-.704.017-.96C3.552 2.003 6.813.157 9.975.008c.93-.044 1.866.082 2.81.376z", transform: "translate(-2 -32) translate(0 28) translate(2 6)" }),
        React.createElement("path", { d: "M13 2.2v19.6c0 .11-.09.2-.2.2h-1.6c-.11 0-.2-.09-.2-.2V2.2c0-.11.09-.2.2-.2h1.6c.11 0 .2.09.2.2z", transform: "translate(-2 -32) translate(0 28) rotate(45 12 12)" }),
        React.createElement("path", { d: "M13 2.2v19.6c0 .11-.09.2-.2.2h-1.6c-.11 0-.2-.09-.2-.2V2.2c0-.11.09-.2.2-.2h1.6c.11 0 .2.09.2.2z", transform: "translate(-2 -32) translate(0 28) rotate(45 12 12)" })));
}
export default styled(EyeInvisibleIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
